<template>
  <div>
    <cms-form @submit="createPost"
              :loading="loading">
    </cms-form>
  </div>
</template>
<script>
  import CmsForm from './CmsForm'
  import CMSService from 'src/services/CMSService'
  export default {
    name: 'cms-create',
    components: {
      CmsForm
    },
    data () {
      return {
        loading: false
      }
    },
    methods: {
      async createPost(post) {
        try {
          this.loading = true
          await CMSService.create(post)
          this.$router.push('/content/cms')
        } catch (e) {
          console.warn(e)
        }
        this.loading = false
      }
    }
  }
</script>
<style>
</style>
